import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import cardMetaData from '~/api/cardMetaData.api';
import { handleThunkException } from '~/services/thunk.service';

export const fetchCardMetaDataApi = createAsyncThunk(
    'cardSaga/cardMetaData/fetchCardMetaDataApi',
    async (navigate, { dispatch }) => {
        try {
            // dispatch(requestStarted()); //disabled this `dispatch`, else Update component of all cards will be re-rendered unnecessarily.
            const data = await cardMetaData.getAll();
            dispatch(fetchCardMetaData(data));
            // dispatch(requestFinished());
        } catch (error) {
            handleThunkException(error, dispatch, navigate);
        }
    },
);

export const cardMetaDataSlice = createSlice({
    name: 'cardSaga/cardMetaData',
    initialState: { cardMetaData: {} },
    reducers: {
        fetchCardMetaData(state, action) {
            return { ...state, cardMetaData: action.payload };
        },
    },
});

export const { fetchCardMetaData } = cardMetaDataSlice.actions;
